export default "__VITE_ASSET__BficPJVt__"